// extracted by mini-css-extract-plugin
module.exports = {"container":"container__container___2Wq7c","snap":"container__snap___1RrVv"};